import { cca_config } from '../../../../../CCA_ENV_CONF/env';
import EditTauxAssurance from '@/components/caisse/manage-bons/edit-taux-assurance';
import PaymentConfirmation from '@/components/caisse/manage-bons/confirm-payment'
import TicketCaisse from '@/components/caisse/ticket-caisse';
import PrintBonMedical from '@/components/caisse/manage-bons/print-bon-medical'
import GroupTaxation from '@/components/caisse/choix-groupe-taxation'
import store_operation from '@/store/mods/caisse/operations'
import { openMenu, closeMenu, open_menu_state } from '@/function/function.js';
import $ from 'jquery'

export default {
    name: 'bon-medical',
    components: {
        EditTauxAssurance, PaymentConfirmation,
        TicketCaisse, GroupTaxation, PrintBonMedical
    },
    props: [],
    data() {
        return {
            vm_state: open_menu_state,
            is_loading: true,
            is_printing: false,
            is_printable: false,
            is_bon_analyse: false,
            is_reloading_tarif: false,
            libelle_bon: '',

            bon_is_printable: false,
            save_loading: false,
            info_bon: {},
            is_bon_consultation: false,

            can_pay: true,
            error_message: "",
            undefined_pac_error_message: "",
            warning_message: "",
            warning_contrat_expire: "",
            warning_exclusion: "",
            toggle_payment_state: 0,
            etat_paiement: '',

            compte_id: 0,
            can_pay_with_deposit: false,
            depot_data: {},
            info_assurance: {},
            taux_couverture: '',
            prix_assure: 0,
            prix_assureur: 0,
            total_a_payer: 0,
            total_prix_vente: 0,
            total_net_a_payer: 0,
            tot_base_assurance: 0,

            tmp_base_assurance: 0,
            tmp_prix_assure_clinique: 0,

            part_assure_by_prestation: 0,
            part_assureur_by_prestation: 0,

            prestations: [],
            consultation_data: {},
            prestation_data: {
                data_type: '',
                libelle: ''
            },

            warning_prestations: [],
            excluded_prestations: [],
            pac_undefined_prestations: [],
            undefined_taxation_prestations: [],
            paiement_data: {},
            ticket_caisse_info: {},

            patient_data: {},
            filename: '',

            aib_liste: [
                {
                    libelle: 'N/A',
                    taux: 0,
                    slug: 'n_a'
                }
            ],
            selected_aib: {
                libelle: 'N/A',
                taux: 0,
                slug: 'n_a'
            },

            groupes_taxation: [],
            type_factures: [],
            taxation_data: {},
            taxation_togller: 0,

            ventilation_impots: [],
            recap_ventilation_impots: {},
            sfe_data: {},

            total_taxe_specifique: 0,
            total_imposable_aib: 0,
            impot_aib: 0,
            current_taxation: {},
            can_show_groupe_for_prestation: false,
            prix_apport_social: 0,
            colspans: {
                colspan_1: '',
                colspan_2: '',
                colspan_3: '',
                colspan_4: ''
            },

            all_checked: false,
            operations_to_pay: [],
            info_caissier: {},
            can_print: false,
            a_model_forfait: 0
        }
    },

    watch: {
        selected_aib() {
            if (Object.prototype.hasOwnProperty.call(this.current_taxation, 'group_taxation')) {
                this.initPrix()
                this.handleVentilationCalculation(this.current_taxation)
                this.calculate_prix_a_payer()
            }
        },
    },

    computed: {
        /**
         * User Info
         * @returns 
         */
        userCredentials() {
            return this.$store.getters['authInfo'];
        },

        activeRole() {
            return this.$store.getters['activeRole'];
        },

        patient() {
            return this.$store.getters["patient"];
        },

        can_add_differential_computing() {
            return this.$store.getters["can_add_differential_computing"]
        },

        depot_patient() {
            return this.$store.getters['depot_patient'];
        },

        analyses_selected() {
            return this.$store.getters['analyses_selected']
        },
        
        examens_selected() {
            return this.$store.getters['examens_selected']
        },

        tarif_group_prestation() {
            return this.$store.getters['tarif_group_prestation']
        },

        chosen_patient() {
            return this.$store.getters["chosen_patient"];
        },

        sfe_liste_aib() {
            return this.$store.getters['sfe_liste_aib'];
        },

        sfe_groupes_taxation() {
            return this.$store.getters['sfe_groupes_taxation'];
        },

        divers_info() {
            return this.$store.getters["divers_info"];
        },

        is_pre_saved_bon() {
            return this.$store.getters["is_pre_saved_bon"];
        },
    },

    mounted() {
        if (this.has_two_currencies) {
            this.currency_info = this.$store.getters['info_currency']
        }
        
        this.setColspans()
        this.setTypeDeBon() 

        if (this.activeRole.nom == 'ROLE_CAISSIERE') {
            this.compte_id = 1 //  Caisse principale
        } else if (this.activeRole.nom == 'ROLE_CAISSIERE_INTERMITENT') {
            this.compte_id = 4 //  Caisse 1 (Infirmier)
        } else if (this.activeRole.nom == 'ROLE_COMPTABLE') {
            this.compte_id = 3 //  Comptabilité
        }

        this.info_caissier = {
            nom_caissier: this.userCredentials.user.name,
            titre: this.userCredentials.user.titre
        }

        // Check if Differential computing should be applied
        this.$store.dispatch('getDifferentialComputing')

        const ts = this;
        $(document).bind("click", function (e) {
            const $clicked = $(e.target);
            if (!$clicked.parents().hasClass("option-container")) {
                if (ts.vm_state != 0) {
                    ts.openMenu(ts.vm_state, 'option-box', 'animate-zoomIn', 'animate-zoomOut')
                }
            }
        });

        // Check depot patient
        this.checkDepotPatient()

        this.getTarifGroupPrestation()

        if (cca_config.IS_SFE) {
            // AIB SFE
            this.getListeAibSFE()

            // Groupe taxation
            this.getGroupeTaxationSFE()
        }

        this.initVentilationImpot()
        this.getDiversInfo()
    },
    
    methods: {
        getDiversInfo() {
            this.$store.dispatch('getConfigInfoClinique', 'divers_info')
        },

        setColspans() {
            if (this.is_sfe) {
                if (this.can_set_pac) {
                    this.colspans.colspan_1 = 7
                } else {
                    this.colspans.colspan_1 = 6
                }
                this.colspans.colspan_2 = 5
            } else {
                if (this.can_set_pac) {
                    this.colspans.colspan_1 = 6
                } else {
                    this.colspans.colspan_1 = 5
                }
                this.colspans.colspan_2 = 4
            }
        },

        /**
         * Open Menu Dropdown
         */
        openMenu(state, selector, show_in, show_out) {
            this.vm_state = openMenu.dropMenu(state, selector, show_in, show_out)
        },

        /**
         * Close Menu Dropdown
         */
        closeMenu(selector, show_in, show_out) {
            this.vm_state = closeMenu.wrapMenu(selector, show_in, show_out)
        },

        checkDepotPatient() {
            // Depot patient
            this.$store.dispatch('getDepotPatient', this.chosen_patient.id).then(() => {
                if (this.depot_patient.length == 0) {
                    this.can_pay_with_deposit = false
                } else {
                    this.can_pay_with_deposit = true
                }
            })
        },

        setTypeDeBon() {
            if (this.analyses_selected.length > 0) {
                this.is_bon_analyse = true
                this.libelle_bon = 'Bon d\'analyse'
                this.prestation_data = {
                    data_type: 'analyse',
                    libelle: 'Bon d\'analyse'
                }
            } else if (this.examens_selected.length > 0) {
                this.is_bon_analyse = false
                this.libelle_bon = 'Bon d\'examen'
                this.prestation_data = {
                    data_type: 'examen',
                    libelle: 'Bon d\'examen'
                }
            }
        },

        getTarifGroupPrestation() {
            this.is_loading = true 

            const data = {
                patient_id: this.chosen_patient.id,
                data_type: (this.is_bon_analyse)?'analyse':'examen',
                prestations: (this.is_bon_analyse)?this.analyses_selected:this.examens_selected,
                can_set_pac: this.can_set_pac
            }
            this.$store.dispatch('getTarifByGroupPrestation', data).then(() => {
                if (!this.InsuranceIsValid(this.tarif_group_prestation.assur_est_expire)) {
                    this.warning_contrat_expire = "Le contrat d'assurrance de ce patient est expiré. En continuant, il sera traité comme un patient non assuré."
                }

                // Taux de couverture
                this.taux_couverture = (this.tarif_group_prestation.taux_couverture != '')?''+(this.tarif_group_prestation.taux_couverture * 100):''
               
                // Info assurance
                this.info_assurance = {
                    taux_couverture: this.taux_couverture,
                    est_assure: this.tarif_group_prestation.est_assure,
                    est_expire: this.tarif_group_prestation.assur_est_expire,
                    assurance_id: (this.tarif_group_prestation.assureur_id != null)?this.tarif_group_prestation.assureur_id:'',
                    assurance: this.tarif_group_prestation.assureur,
                    souscripteur_id: (this.tarif_group_prestation.souscripteur_id != null)?this.tarif_group_prestation.souscripteur_id:'',
                    souscripteur: (this.tarif_group_prestation.souscripteur != null)?this.tarif_group_prestation.souscripteur:'',
                    assure_principal_id: (this.tarif_group_prestation.assure_principal_id != null)?this.tarif_group_prestation.assure_principal_id:'',
                }
                this.a_model_forfait = this.tarif_group_prestation.a_model_forfait

                // Si patient sous société forfaitaire; forcer le taux à 100%
                if (this.a_model_forfait === 1) {
                    this.taux_couverture = 100
                    this.info_assurance.taux_couverture = 100
                }

                this.tarif_group_prestation.prestations.forEach((prestation, index) => {
                    let tmp_prix_clinique_net = 0
                    if (this.can_set_pac && this.tarif_group_prestation.est_assure) {
                        if (prestation.est_exclu) {
                            tmp_prix_clinique_net = prestation.prix_clinique
                        } else {
                            tmp_prix_clinique_net = prestation.prix_assure_clinique
                        }
                    } else {
                        tmp_prix_clinique_net = (prestation.prix_clinique > prestation.prix_base_calcul)?prestation.prix_clinique:prestation.prix_base_calcul
                    }
                    this.tarif_group_prestation.prestations[index]['prix_clinique_net'] = tmp_prix_clinique_net
                })

                this.checkPrestations()

                this.is_loading = false
            })
        },

        checkPrestations() {
            setTimeout(() => {
                this.tarif_group_prestation.prestations.forEach(prestation => {
                    let checker = document.getElementById("op-"+prestation.id)
                    if (checker) {
                        checker.checked = true
                    }

                    this.operations_to_pay.push(prestation)
                })
                this.calculate_prix_a_payer()
            }, 1000);
            
        },

        calculate_prix_a_payer() {
            this.total_a_payer = 0
            this.tot_base_assurance = 0
            this.prix_assureur = 0
            this.prix_assure = 0

            this.prestations = []
            let one_price_is_undefined = false
            this.warning_prestations = []
            this.pac_undefined_prestations = []
            this.excluded_prestations = []
            this.undefined_taxation_prestations = []
            this.warning_message = ""
            this.error_message = ""

            const impot_additionel = (this.impot_aib > 0)?this.impot_aib:0

            this.operations_to_pay.forEach(prestation => {
                // if (this.can_set_pac && this.tarif_group_prestation.est_assure) {
                //     if (prestation.est_exclu) {
                //         tmp_prix_clinique_net = prestation.prix_clinique
                //     } else {
                //         tmp_prix_clinique_net = prestation.prix_assure_clinique
                //     }
                // } else {
                //     tmp_prix_clinique_net = (prestation.prix_clinique > prestation.prix_base_calcul)?prestation.prix_clinique:prestation.prix_base_calcul
                // }

                let prix_clinique = prestation.prix_clinique_net
                let base_assurance = prestation.tmp_base_assurance
                const prix_non_assure = prestation.prix_clinique
                // const prix_additionnel = prestation.prix_additionnel
                const prix_assure_clinique = prestation.tmp_prix_assure_clinique

                let is_facture_compl = 1
                if (this.a_model_forfait === 1) {
                    is_facture_compl = 0

                    if (prestation.est_exclu === 1) {
                        is_facture_compl = 1
                    } else {
                        is_facture_compl = 0
                        if (prestation.etat_demande_autorisation === 2) {
                            is_facture_compl = 1
                        } 
                    }
                }

                if (this.tarif_group_prestation.est_assure == 1 && this.tarif_group_prestation.assur_est_expire == 0) {
                    if (prestation.est_exclu == 1) {
                        is_facture_compl = 1
                        this.warning_exclusion = "Une ou plusieurs prestations ont été exclues. En continuant, le patient paiera la totalité des prestations concernées"
                        this.excluded_prestations.push(
                            {
                                libelle: prestation.libelle
                            }
                        )
                    }
                }

                // Check if is PA is set
                if (this.tarif_group_prestation.est_assure && this.can_set_pac && prestation.est_exclu == 0 && (prix_assure_clinique == null || prix_assure_clinique === "")) {
                    this.undefined_pac_error_message = "Le prix assuré d'une ou plusieurs prestations n'a pas été défini"
                    one_price_is_undefined = true
                    this.pac_undefined_prestations.push(
                        {
                            libelle: prestation.libelle
                        }
                    )
                    return
                }

                const prix_is_empty = this.validateStringNotEmpty(prix_clinique)
                if (!prix_is_empty) {
                    prix_clinique = this.cleanNumber(prix_clinique)
                    this.can_pay = this.checkIfCanPay(prix_clinique)

                    if (!this.can_pay) {
                        this.error_message = "Le prix d'une ou plusieurs prestations n'ont pas été définis !"
                        one_price_is_undefined = true
                        return;
                    }
                } else {
                    this.error_message = "Le prix d'une ou plusieurs prestations n'ont pas été définis !"
                    one_price_is_undefined = true
                    return;
                }
                

                if (this.tarif_group_prestation.est_assure == 1 && this.tarif_group_prestation.assur_est_expire == 0) {
                    const base_is_empty = this.validateStringNotEmpty(base_assurance)
                    if (!base_is_empty) {
                        base_assurance = this.transformToNumber(base_assurance)
                    }
                    if ((base_assurance == null || base_assurance === '') && prestation.est_exclu == 0) {
                        this.error_message = "La base assurance d'une ou plusieurs prestations n'ont pas été définies"
                        one_price_is_undefined = true
                        this.warning_prestations.push(
                            {
                                libelle: prestation.libelle
                            }
                        )
                        return;
                    } 

                    // base_assurance = this.cleanNumber(base_assurance)
                    // this.can_pay = this.checkIfCanPay(base_assurance)

                    // if (!this.can_pay && prestation.est_exclu == 0) {
                    //     this.error_message = "La base assurance d'une ou plusieurs prestations n'ont pas été définies !"
                    //     one_price_is_undefined = true
                    //     return;
                    // }
                    
                }

                let valeur_ajoutee = 0
                if (prestation.taxe_specifique > 0) {
                    valeur_ajoutee = parseFloat( prestation.taxe_specifique * (1 + (prestation.group_taxation.taux/ 100)) ).toFixed(0)
                    valeur_ajoutee = parseInt(valeur_ajoutee)
                }

                let prix_considere = 0
                prix_considere = prix_clinique
                this.part_assureur_by_prestation = 0
                this.part_assure_by_prestation = 0
                if (
                    this.tarif_group_prestation.est_assure == 0 || 
                    (this.tarif_group_prestation.est_assure == 1 && prestation.est_exclu == 0)
                ) {
                    // Considérer le prix le plus élévé entre le prix clinique et la base assurance
                    // prix_considere = (prix_clinique > base_assurance)?prix_clinique:base_assurance

                    const param_assure = {
                        base_assurance: base_assurance,
                        prix_assure_clinique: prix_assure_clinique,
                        taux_couverture: this.taux_couverture,
                        pu: prix_non_assure,
                        valeur_ajoutee: valeur_ajoutee,
                        est_exclu: prestation.est_exclu
                    }
                    
                    this.sum_prix_assureur(param_assure)
                    this.sum_prix_assure(param_assure)

                    if (this.tarif_group_prestation.est_assure == 0) {
                        this.part_assure_by_prestation = prix_clinique
                    }
                } else {
                    // prix_considere = prix_clinique
                    this.part_assure_by_prestation = prix_considere
                    this.prix_assure += this.part_assure_by_prestation       // Cas d'exclusion
                }

                const tmp_prestation = {
                    data_type: (this.is_bon_analyse)?'analyse':'examen',
                    est_exclu: prestation.est_exclu,
                    id: prestation.id,
                    libelle: prestation.libelle,
                    prix: prestation.prix_clinique,
                    prix_clinique: prestation.prix_clinique,
                    prix_vente: (this.tarif_group_prestation.est_assure == 1)?this.part_assure_by_prestation:prix_considere,
                    group_taxation: prestation.group_taxation,
                    taxe_specifique: prestation.taxe_specifique,
                    net_paye: 0,
                    base_assurance: (base_assurance)?base_assurance:0,
                    part_assureur: this.part_assureur_by_prestation,
                    prix_assure_clinique: prix_assure_clinique,
                    coupon_remise: 0,
                    qte: 1,
                    is_facture_compl: is_facture_compl
                }
                this.prestations.push(tmp_prestation)
                
                this.total_a_payer += prix_considere
            });

            this.can_pay = (one_price_is_undefined)?false:true
            this.total_a_payer += impot_additionel
            

            if (this.tarif_group_prestation.est_assure == 0) {
                this.total_net_a_payer = this.total_a_payer 
            } else {
                this.total_net_a_payer = this.prix_assure + impot_additionel
            }
        },

        /**
         * Part assureur
         * @param {*} taux_couverture 
         */
        sum_prix_assureur(param_assure) {
            let part_assureur = 0
            let total_pac =  param_assure.prix_assure_clinique
            let tmp_part_assureur = 0
            if (param_assure.base_assurance > 0) {
                tmp_part_assureur = parseInt( (param_assure.taux_couverture * param_assure.base_assurance) / 100) 
            }

            if (this.can_set_pac) {
                if (total_pac <= tmp_part_assureur) {
                    part_assureur = total_pac
                } else {
                    part_assureur = tmp_part_assureur
                }
            } else {
                part_assureur = tmp_part_assureur
            }

            this.part_assureur_by_prestation = part_assureur
            this.prix_assureur += this.part_assureur_by_prestation

            this.tot_base_assurance += param_assure.base_assurance
        },

        sum_prix_assure(param_assure) {
            this.part_assure_by_prestation = this.calcPartAssure(param_assure)  + param_assure.valeur_ajoutee
            this.prix_assure += this.part_assure_by_prestation
        },

        calcPartAssure(param_assure) {
            let part_assure = 0
            if (param_assure.est_exclu == 0 && param_assure.base_assurance >= 0) {
                if (this.can_set_pac && param_assure.prix_assure_clinique < param_assure.base_assurance) {
                    let tmp_part_assureur = 0
                    if (param_assure.base_assurance > 0) {
                        tmp_part_assureur = parseInt( (param_assure.taux_couverture * param_assure.base_assurance) / 100)
                    }

                    let total_pac = 0
                    if (param_assure.prix_assure_clinique > 0) {
                        total_pac =  param_assure.prix_assure_clinique

                        if (total_pac <= tmp_part_assureur) {
                            part_assure = 0
                        } else {
                            part_assure = total_pac - tmp_part_assureur
                        }
                    }
                } else {
                    if (this.can_add_differential_computing.response == "Oui") {
                        let pac = 0
                        if (this.can_set_pac) {
                            pac = (param_assure.prix_assure_clinique === '')?0:param_assure.prix_assure_clinique
                        } else {
                            pac = param_assure.pu
                        }

                        const prix_additionnel = (pac > param_assure.base_assurance)?(pac - param_assure.base_assurance):0
                        part_assure = Math.ceil( ( ( (100 - param_assure.taux_couverture) / 100 ) * param_assure.base_assurance ) +
                            +  parseInt(prix_additionnel) )
                    } else {
                        part_assure = ( Math.ceil( ( (100 - param_assure.taux_couverture) / 100 ) * param_assure.base_assurance ))
                    }
                }
            } else {
                if (this.can_set_pac && this.tarif_group_prestation.est_assure) {
                    part_assure = 0
                } else {
                    part_assure = param_assure.pu
                }
            }
            return part_assure
        },

        initPrix() {
            this.prix_assure = 0
            this.prix_assureur = 0
            this.tot_base_assurance = 0
        },

        /**
         * Check if continue payment
         * @param {*} amount 
         */
        checkIfCanPay(amount) {
            amount = +amount
            if (amount == 0) {
                return false
            }
            return true
        },

        handleBaseAssuranceChange(index, is_base_assur) {
            const prix_unitaire = this.tarif_group_prestation.prestations[index].prix_clinique
            const est_exclu = this.tarif_group_prestation.prestations[index].est_exclu
            let prix_assure_clinique = ''
            let base_assurance = ''

            if (is_base_assur) {
                prix_assure_clinique = parseInt(this.tarif_group_prestation.prestations[index].tmp_prix_assure_clinique)

                const base_assur_input = document.getElementById('pbassur'+this.tarif_group_prestation.prestations[index].id)
                if (!base_assur_input) {
                    return;
                }

                base_assurance = base_assur_input.value
                if (base_assurance == '') {
                    base_assur_input.value = 0
                } 

                const base_assur_is_empty = this.validateStringNotEmpty(base_assurance)
                if (!base_assur_is_empty) {
                    base_assurance = this.transformToNumber(base_assurance)
                } else {
                    base_assurance = 0
                }
            } else {
                base_assurance = this.tarif_group_prestation.prestations[index].tmp_base_assurance

                const pac_input = document.getElementById('p_pac'+this.tarif_group_prestation.prestations[index].id)
                if (!pac_input) {
                    return;
                }

                prix_assure_clinique = pac_input.value

                if (prix_assure_clinique == '') {
                    pac_input.value = 0
                } 

                const pac_is_empty = this.validateStringNotEmpty(prix_assure_clinique)
                if (!pac_is_empty) {
                    prix_assure_clinique = this.transformToNumber(prix_assure_clinique)
                } else {
                    prix_assure_clinique = 0
                }
            }

            this.tarif_group_prestation.prestations[index].tmp_base_assurance = base_assurance
            this.tarif_group_prestation.prestations[index].tmp_prix_assure_clinique = prix_assure_clinique

            if (this.can_set_pac && this.tarif_group_prestation.est_assure) {
                this.tarif_group_prestation.prestations[index].prix_clinique_net = prix_assure_clinique
            } else {
                this.tarif_group_prestation.prestations[index].prix_clinique_net = (prix_unitaire > base_assurance)?prix_unitaire:base_assurance
            }

            let montant_a_payer = 0
            if (this.tarif_group_prestation.est_assure) {

                const param_assure = {
                    base_assurance: base_assurance,
                    prix_assure_clinique: prix_assure_clinique,
                    taux_couverture: this.taux_couverture,
                    pu: prix_unitaire,
                    qte: 1,
                    est_exclu: est_exclu
                }
                montant_a_payer = this.calcPartAssure(param_assure)

                this.calculate_prix_a_payer()
            } else {
                montant_a_payer = prix_unitaire
            }


            const info_taxation = {
                group_taxation: this.tarif_group_prestation.prestations[index].group_taxation,
                prestation: this.tarif_group_prestation.prestations[index].libelle,
                taxe_specifique: this.tarif_group_prestation.prestations[index].taxe_specifique,
                prix: montant_a_payer,
                qte: 1
            }
            this.updateGroupTaxation(info_taxation)

        
            // else {
            //     montant_a_payer = prix_unitaire
            // }

            // // this.can_pay = true
            // this.calculate_prix_assure(this.taux_couverture)
            // this.calculate_prix_assureur(this.taux_couverture)

            // const info_taxation = {
            //     group_taxation: selected_bon.group_taxation,
            //     prestation: selected_bon.consult_name,
            //     taxe_specifique: selected_bon.taxe_specifique,
            //     prix: this.prix_assure,
            //     qte: 1
            // }
            // this.updateGroupTaxation(info_taxation)
        },

        setToPrintable() {
            this.is_printable = true
        },

        onPayment(etat_paiement) {
            this.etat_paiement = etat_paiement
            this.payWithDeposit()
            
            this.toggle_payment_state = (this.toggle_payment_state == 0)?1:0

            if (!cca_config.IS_SFE) {
                this.selected_aib = {
                    libelle: '',
                    taux: 0,
                    slug: ''
                }
            }

            this.recap_ventilation_impots = this.ventilation_impots.filter((ventilation) => ventilation.can_show)
            this.sfe_data = {
                recap_ventilation_impots: this.recap_ventilation_impots,
                total_taxe_specifique: this.total_taxe_specifique,
                info_aib: this.selected_aib,
                impot_aib: this.impot_aib,
                total_imposable_aib: this.total_imposable_aib
            }
        },

        payWithDeposit() {
            this.depot_data = {}
            if (this.etat_paiement == 'depot') {
                this.depot_data = this.depot_patient
            }
        },

        refreshTarification(taux) {
            this.prix_assure = 0
            this.prix_assureur = 0
            this.tot_base_assurance = 0
            this.is_reloading_tarif = true
            this.taux_couverture = taux
            this.info_assurance.taux_couverture = taux
            this.calculate_prix_a_payer()

            setTimeout(() => {
                this.is_reloading_tarif = false
            }, 500);
        },

        sendBonMedicalData(data) {
            const paiement_data = data.paiement
            paiement_data.prestations.forEach(prestation => {
                this.total_prix_vente += prestation.prix_vente
            });

            if (data.data_type == 'analyse') {
                this.saveBonAnalyse(data)
            } else {
                this.saveBonExamen(data)
            }
        },

        saveBonAnalyse(data) {
            const analyse_data = {
                bulletin_id: 0,
                user_id: this.userCredentials.user.id,
                consultation_id: 0,
                evolution_id: 0,
                renseignement_clinique: '',
                choix_type_demande: 'interne', 
                analyses: data.prestations,
                etat_paiement: data.etat_paiement,
                patient_id: this.chosen_patient.id,
                nom_patient: this.chosen_patient.nom,
                sexe: this.chosen_patient.sexe,
                telephone: this.chosen_patient.telephone_mobile,
                assurance: this.tarif_group_prestation.assureur,
                societe_souscripteur: this.tarif_group_prestation.souscripteur,
            }

            const tmpstamp = this.current_date.getTime()
            this.filename = 'Bon d\'analyse_'+this.chosen_patient.nom+'_'+tmpstamp

            this.$store.dispatch('saveBulletinAnalyse', analyse_data).then((response) => {
                if (response.success) {
                    this.successToast("Bon d'analyse enregistré avec succès")

                    this.paiement_data = data.paiement
                    this.ticket_caisse_info = data.ticket_info

                    this.setToPrintable()
                } else {
                    this.warningToast("Une erreur s'est produite lors de l'enregistrement !")
                }
            }).catch(() => {
                this.warningToast("Une erreur s'est produite lors de l'enregistrement !")
            })
        },

        saveBonExamen(data) {
            const examen_data = {
                bulletin_id: 0,
                user_id: this.userCredentials.user.id,
                consultation_id: 0,
                evolution_id: 0,
                renseignement_clinique: '',
                choix_type_demande: 'interne', 
                examen_selectionnes: data.prestations,
                etat_paiement: data.etat_paiement,
                patient_id: this.chosen_patient.id,
                nom_patient: this.chosen_patient.nom,
                sexe: this.chosen_patient.sexe,
                telephone: this.chosen_patient.telephone_mobile,
                assurance: this.tarif_group_prestation.assureur,
                societe_souscripteur: this.tarif_group_prestation.souscripteur,
            }

            const tmpstamp = this.current_date.getTime()
            this.filename = 'Bon d\'examen_'+this.chosen_patient.nom+'_'+tmpstamp

            this.$store.dispatch('saveDemandeExamen', examen_data).then((response) => {
                if (response.success) {
                    this.successToast("Bon d'examen enregistré avec succès")

                    this.paiement_data = data.paiement
                    this.ticket_caisse_info = data.ticket_info
                    this.setToPrintable()
                } else {
                    this.warningToast("Une erreur s'est produite lors de l'enregistrement !")
                }
            }).catch(() => {
                this.warningToast("Une erreur s'est produite lors de l'enregistrement !")
            })
        },

        getGroupeTaxationSFE() {
            const data = {
                data_type: 'taxation_type',
                endpoint: 'taxGroups'
            }
            this.$store.dispatch('getInfoSFE', data).then(() => {
                const groupe_taxation = Object.keys(this.sfe_groupes_taxation);

                const taxation_items = ['a', 'b', 'c', 'd', 'e', 'f']
                groupe_taxation.forEach(key => {
                    if (taxation_items.includes(key)) {
                        const tmp_aib = {
                            libelle: this.setLibelleGroupTaxation(key),
                            taux: this.sfe_groupes_taxation[key],
                            slug: key
                        }
                        this.groupes_taxation.push(tmp_aib)
                    }
                });
            })
        },

        async initVentilationImpot() {
            const data = {
                data_type: 'taxation_type',
                endpoint: 'taxGroups'
            }
            await this.$store.dispatch('getInfoSFE', data).then(() => {
                const groupe_taxation = Object.keys(this.sfe_groupes_taxation);

                const taxation_items = ['a', 'b', 'c', 'd', 'e', 'f']
                groupe_taxation.forEach(key => {
                    if (taxation_items.includes(key)) {
                        const tmp_ventilation = {
                            libelle: this.setLibelleGroupTaxation(key),
                            taux: this.sfe_groupes_taxation[key],
                            impot: 0, 
                            imposable: 0,
                            total: 0,
                            can_show: false,
                            prestations: []
                        }
                        this.ventilation_impots.push(tmp_ventilation)
                    }
                });
            })
        },

        getListeAibSFE() {
            const data = {
                data_type: 'taxation_type',
                endpoint: 'taxGroups'
            }
            this.$store.dispatch('getInfoSFE', data).then(() => {

                const listes_aib = Object.keys(this.sfe_liste_aib);
                const aib_items = ['aibA', 'aibB']

                listes_aib.forEach(key => {
                    if (aib_items.includes(key)) {
                        const tmp_aib = {
                            libelle: this.setLibelleGroupTaxation(key),
                            taux: this.sfe_liste_aib[key],
                            slug: key
                        }
                        this.aib_liste.push(tmp_aib)
                    }
                });
            })
        },

        setGroupTaxation(prestation, is_grouped) {
            let prix_prestation = 0
            if (!is_grouped) {
                const param_assure = {
                    base_assurance: prestation.tmp_base_assurance,
                    prix_assure_clinique: prestation.tmp_prix_assure_clinique,
                    taux_couverture: this.taux_couverture,
                    pu: prestation.prix_clinique,
                    est_exclu: prestation.est_exclu
                }
                
                if (prestation.est_exclu) {
                    prix_prestation = prestation.prix_clinique
                } else {
                    prix_prestation = (this.tarif_group_prestation.est_assure)?this.calcPartAssure(param_assure):prestation.prix_clinique
                }
            }

            const tmp_group_taxation = this.groupes_taxation[0]
            
            this.taxation_data = {
                data_type: "",
                prestation: (!is_grouped)?prestation.libelle:this.libelle_bon,
                uid: "",
                group_taxation: (!is_grouped)?prestation.group_taxation:tmp_group_taxation,
                taxe_specifique: (!is_grouped)?prestation.taxe_specifique:"",
                prix: (!is_grouped)?prix_prestation:0,
                is_grouped: is_grouped,
                index: 0
            }

            this.taxation_togller = (this.taxation_togller == 0)?1:0
        },

        setGroupTaxationToUpdate(data) {
            if (data.is_grouped) {
                this.fillAllGroupTaxation(data.group_taxation, data.taxe_specifique)
            } else {
                this.updateGroupTaxation(data)
            }
        },

        fillAllGroupTaxation(selected_group_taxation, taxe_specifique) {
            let valeur_ajoutee = 0
            this.tarif_group_prestation.prestations.forEach((prestation, index) => {
                this.tarif_group_prestation.prestations[index].group_taxation = selected_group_taxation
                this.tarif_group_prestation.prestations[index].taxe_specifique = taxe_specifique
                this.tarif_group_prestation.prestations[index].slug_taxation = this.capitalizeFirstLetter(selected_group_taxation.slug)

                let tmp_prix_clinique_net = 0
                if (this.can_set_pac && this.tarif_group_prestation.est_assure) {
                    if (prestation.est_exclu) {
                        tmp_prix_clinique_net = prestation.prix_clinique
                    } else {
                        let tmp_pac = prestation.tmp_prix_assure_clinique
                        const pac_is_empty = this.validateStringNotEmpty(tmp_pac)
                        if (!pac_is_empty) {
                            tmp_pac = this.transformToNumber(tmp_pac)
                        }
                        tmp_prix_clinique_net = parseInt(tmp_pac)
                    }
                } else {
                    tmp_prix_clinique_net = (prestation.prix_clinique > prestation.tmp_base_assurance)?prestation.prix_clinique:prestation.tmp_base_assurance
                }

                if (taxe_specifique > 0) {
                    valeur_ajoutee = parseFloat( taxe_specifique * (1 + (selected_group_taxation.taux / 100)) ).toFixed(0)
                    valeur_ajoutee = parseInt(valeur_ajoutee)
                    this.tarif_group_prestation.prestations[index]['prix_clinique_net'] = tmp_prix_clinique_net + valeur_ajoutee
                } else {
                    this.tarif_group_prestation.prestations[index]['prix_clinique_net'] = tmp_prix_clinique_net
                }

                let montant_a_payer = 0
                if (this.tarif_group_prestation.est_assure) {

                    const param_assure = {
                        base_assurance: prestation.tmp_base_assurance,
                        prix_assure_clinique: prestation.tmp_prix_assure_clinique,
                        taux_couverture: this.taux_couverture,
                        pu: prestation.prix_clinique,
                        qte: 1,
                        est_exclu: prestation.est_exclu
                    }
                    montant_a_payer = this.calcPartAssure(param_assure)
                } else {
                    montant_a_payer = prestation.prix_clinique
                }

                const info_taxation = {
                    group_taxation: selected_group_taxation,
                    prestation: this.tarif_group_prestation.prestations[index].libelle,
                    taxe_specifique: this.tarif_group_prestation.prestations[index].taxe_specifique,
                    prix: montant_a_payer,
                    qte: this.tarif_group_prestation.prestations[index].qte
                }
                this.updateGroupTaxation(info_taxation)
            });
        },

        updateGroupTaxation(data) {
            let valeur_ajoutee = 0

            this.tarif_group_prestation.prestations.forEach((prestation, index) => {
                if (prestation.libelle == data.prestation) {
                    this.tarif_group_prestation.prestations[index].group_taxation = data.group_taxation
                    this.tarif_group_prestation.prestations[index].taxe_specifique = data.taxe_specifique
                    this.tarif_group_prestation.prestations[index].slug_taxation = (data.group_taxation == "")?"":this.capitalizeFirstLetter(data.group_taxation.slug)

                    let tmp_prix_clinique_net = 0
                    if (this.can_set_pac && this.tarif_group_prestation.est_assure) {
                        if (prestation.est_exclu) {
                            tmp_prix_clinique_net = prestation.prix_clinique
                        } else {
                            let tmp_pac = prestation.tmp_prix_assure_clinique
                            const pac_is_empty = this.validateStringNotEmpty(tmp_pac)
                            if (!pac_is_empty) {
                                tmp_pac = this.transformToNumber(tmp_pac)
                            }
                            tmp_prix_clinique_net = parseInt(tmp_pac)
                        }
                    } else {
                        tmp_prix_clinique_net = (prestation.prix_clinique > prestation.tmp_base_assurance)?prestation.prix_clinique:prestation.tmp_base_assurance
                    }

                    if (data.taxe_specifique > 0) {
                        valeur_ajoutee = parseFloat( data.taxe_specifique * (1 + (data.group_taxation.taux / 100)) ).toFixed(0)
                        valeur_ajoutee = parseInt(valeur_ajoutee)
                        this.tarif_group_prestation.prestations[index]['prix_clinique_net'] = tmp_prix_clinique_net + valeur_ajoutee
                    } else {
                        this.tarif_group_prestation.prestations[index]['prix_clinique_net'] = tmp_prix_clinique_net
                    }
                }
            });

            this.initPrix()
            this.handleVentilationCalculation(data)
            this.calculate_prix_a_payer()
        },

        resetValue(index) {
            this.ventilation_impots[index]['total'] = 0
            this.ventilation_impots[index]['imposable'] = 0
            this.ventilation_impots[index]['impot'] = 0
        },

        handleVentilationCalculation(taxation) {
            this.current_taxation = taxation
            this.total_taxe_specifique = 0
            this.total_imposable_aib = 0
            this.impot_aib = 0

            this.ventilation_impots.forEach((ventilation, index) => {
                if (ventilation.libelle == taxation.group_taxation.libelle) {
                    this.ventilation_impots[index]['can_show'] = true

                    let is_new = true

                    const tmp_ventilation_prestation = {
                        libelle: taxation.prestation,
                        prix: taxation.prix,
                        taxe_specifique: taxation.taxe_specifique, 
                        taux: taxation.group_taxation.taux, 
                    }
                    this.ventilation_impots[index]['prestations'].forEach((prestation, j) => {
                        if (prestation.libelle == taxation.prestation) {
                            is_new = false
                            this.ventilation_impots[index]['prestations'][j]['taxe_specifique'] = taxation.taxe_specifique
                        }
                    });

                    if (is_new) {
                        this.ventilation_impots[index]['prestations'].push(tmp_ventilation_prestation)
                    }
                } else {
                    this.ventilation_impots[index]['prestations'].forEach((prestation, pi) => {
                        if (prestation.libelle == taxation.prestation) {
                            this.ventilation_impots[index]['prestations'].splice(pi, 1)
                        } 
                    });
                }

                this.resetValue(index)
                let sfe_tot = 0
                let sfe_impot = 0
                this.ventilation_impots[index]['prestations'].forEach((prestation, pi) => {
                    if (taxation.prestation == prestation.libelle) {
                        this.ventilation_impots[index]['prestations'][pi]['prix'] = taxation.prix
                        this.ventilation_impots[index]['prestations'][pi]['taxe_specifique'] = taxation.taxe_specifique
                    }

                    let valeur_ajoutee = 0
                    if (prestation.taxe_specifique > 0) {
                        valeur_ajoutee = parseFloat( prestation.taxe_specifique * (1 + (prestation.taux / 100)) ).toFixed(0)

                        this.total_taxe_specifique += prestation.taxe_specifique
                    }
                    valeur_ajoutee = parseInt(valeur_ajoutee)
                    this.ventilation_impots[index]['total'] += (prestation.prix + valeur_ajoutee)
                    sfe_tot = this.ventilation_impots[index]['total']

                    // Calcul imposable
                    if (prestation.taux > 0) {
                        this.ventilation_impots[index]['imposable'] = parseInt(this.ventilation_impots[index]['imposable'])
                        this.ventilation_impots[index]['imposable'] = ( this.ventilation_impots[index]['total'] / (1 + prestation.taux/100) )
                        this.ventilation_impots[index]['imposable'] = parseFloat(this.ventilation_impots[index]['imposable']).toFixed(0)
                        this.ventilation_impots[index]['imposable'] = parseInt(this.ventilation_impots[index]['imposable'])

                        // Calcul impot 
                        this.ventilation_impots[index]['impot'] = this.ventilation_impots[index]['total'] - this.ventilation_impots[index]['imposable'] 
                        sfe_impot = this.ventilation_impots[index]['impot'] 
                    }
                });

                // Calcul AIB
                if (this.selected_aib.libelle != 'N/A') {
                    this.total_imposable_aib += (sfe_tot - sfe_impot)
                }

                this.impot_aib = parseFloat((this.selected_aib.taux / 100) * this.total_imposable_aib).toFixed(0)
                this.impot_aib = parseInt(this.impot_aib)

                // Prestation Analyse | Examen
                let tmp_can_show = false
                this.tarif_group_prestation.prestations.forEach((prestation) => {
                    if (ventilation.libelle === prestation.group_taxation.libelle) {
                        tmp_can_show = true
                    }
                });

                // Eliminate not chosen group from ventilation impots
                if (!tmp_can_show) {
                    this.ventilation_impots[index]['can_show'] = false
                    this.resetValue(index)
                }
            });

            this.ventilation_impots.forEach(ventilation => {
                if (ventilation.can_show == true) {
                    this.can_show_groupe_for_prestation = true
                }
            });
        },

        checkChosenGroupTaxation(vm_state, down_option_box, animate_zoomIn, animate_zoomOut) {
            if (cca_config.IS_SFE) {
                this.warning_prestations = []
                this.excluded_prestations = []
                this.pac_undefined_prestations = []
                this.undefined_taxation_prestations = []
            
                this.operations_to_pay.forEach(prestation => {
                    let has_libelle = false
                    if (Object.prototype.hasOwnProperty.call(prestation.group_taxation, 'libelle')) {
                        has_libelle = true
                    }
                    if (prestation.group_taxation == "" || (has_libelle && prestation.group_taxation.libelle == "")) {
                        this.undefined_taxation_prestations.push(
                            {
                                libelle: prestation.libelle
                            }
                        )
                    }
                });

                if (this.undefined_taxation_prestations.length > 0) {
                    this.warning_message = "Le groupe de taxation d'une ou plusieurs prestations n'a pas été défini !"
                }

                if (this.warning_message != "") {
                    return;
                }
            }

            this.openMenu(vm_state, down_option_box, animate_zoomIn, animate_zoomOut)
        },

        onOneChange(index, prestation_id) {
            this.error_message = ""

            let checked_state = document.getElementById('op-'+prestation_id).checked
            if (!checked_state) {
                this.tarif_group_prestation.prestations[index].group_taxation = ""
                this.tarif_group_prestation.prestations[index].slug_taxation = ""
                this.tarif_group_prestation.prestations[index].taxe_specifique = ""
            }

            if (this.operations_to_pay.length == 0) {
                this.can_pay = false
                this.error_message = "Merci de choisir au moins une prestation à facturer !"
                return
            }
            this.calculate_prix_a_payer()

            let tmp_info_group_taxation = {
                libelle: "",
                slug: "",
                taux: ""
            }

            const info_taxation = {
                group_taxation: tmp_info_group_taxation,
                prestation: this.tarif_group_prestation.prestations[index].libelle,
                taxe_specifique: this.tarif_group_prestation.prestations[index].taxe_specifique,
                prix: this.tarif_group_prestation.prestations[index].prix_unitaire,
                qte: this.tarif_group_prestation.prestations[index].qte
            }
            this.updateGroupTaxation(info_taxation)
        },

        printBon() {
            if(this.activeRole.nom == 'ROLE_ACCUEIL') {
                $('.p-bon-medical').modal('show')
            } else {
                this.can_print = true
                setTimeout(() => {
                    window.print()
                    this.can_print = false
                }, 200);
            }
        },

        setPrestationUid(libelle) {
            const tm = new Date()

            let tmp_uid = libelle
            tmp_uid = tmp_uid.replace(" ", "_")
            tmp_uid = tmp_uid.replace("/", "_")
            tmp_uid = tmp_uid.toLowerCase()+''+tm.getTime()
            tmp_uid = tmp_uid.replace("  ", "_")
            tmp_uid = tmp_uid.replace(" ", "_")
            tmp_uid = tmp_uid.replace("'", "_")
            return tmp_uid
        },

        buildListePrestation() {
            let prestations = []
            if (this.analyses_selected.length > 0) {
                this.analyses_selected.forEach(element => {
                    const tmp_prestation = {
                        uid: this.setPrestationUid(element.nom),
                        data_id: element.id,
                        libelle: element.nom,
                        prix_unitaire: element.prix
                    }
                    prestations.push(tmp_prestation)
                });
            } else if (this.examens_selected.length > 0) {
                this.examens_selected.forEach(element => {
                    const tmp_prestation = {
                        uid: this.setPrestationUid(element.nom),
                        data_id: element.id,
                        libelle: element.nom,
                        prix_unitaire: element.prix
                    }
                    prestations.push(tmp_prestation)
                });
            }
            return prestations
        },

        saveBon() {
            this.msg_error = ''

            const data = {
                data_type: this.prestation_data.data_type,
                uid: this.setPrestationUid(this.prestation_data.libelle),
                title: this.prestation_data.libelle,
                prestations: this.buildListePrestation(),
                patient: this.chosen_patient,
                patient_id: this.chosen_patient.id,
                user_id: this.userCredentials.user.id,
                user: {
                    name: this.userCredentials.user.name,
                    titre: this.userCredentials.user.titre
                },
                info_complementaire: {
                    date_emission: this.getCurrentDate(),
                    est_assure: this.tarif_group_prestation.est_assure,
                    assurance: this.tarif_group_prestation.assureur,
                    societe_souscripteur: this.tarif_group_prestation.souscripteur,
                    taux_couverture: parseInt(this.taux_couverture),
                }
            }
            this.info_bon = data

            this.bon_is_printable = true
            
            this.save_loading = true
            store_operation.saveBonMedical(data).then((response) => {
                if (response.success) {
                    this.successToast(response.message)
                    this.bon_is_printable = true
                } else {
                    this.msg_error = response.message
                }
                this.save_loading = false
            }).catch(() => {
                this.save_loading = false
                this.msg_error = "Une erreur s'est produite ! Merci de réesayer"
            })
        },
    }
}


